export default __webpack_public_path__ + "static/media/loading-HX_white-bg.13ddb5aa.gif";